import { CameraStatus, FragmentHoleType } from '@/globals/enums';

export const handleCameraStatus = (component, status) => {
  component.handleCameraStatus(status);
};

export const handleError = (component) => {
  component.handleCameraStatus(CameraStatus.Error);
  component.errorMessage = component.isLive
    ? {
        text: '映像の再生に失敗しました。接続状態を確認して、もう一度お試しください。',
      }
    : { text: '録画映像なし', theme: 'dark-bg' };
  component.signal = 2;
  component.kinesisVideoError = true;
};

export const handleConnected = (component) => {
  component.errorMessage = null;
  component.signal = 3;
  component.kinesisVideoError = false;
  handleCameraStatus(component, CameraStatus.Connected);
};

export const handleLoaded = (component) => {
  component.checkPlayVideoAfterStreamLoad();
};

export const handleLoading = (component) => {
  component.handleCameraLoading();
};

export const handlePlaylistChanged = (component, playlist, holes) => {
  component.hlsPlaylist = playlist;
  component.allFragmentHoles = holes;
};

export const handleFragmentStatusChanged = (component, frag) => {
  component.$set(
    component.hlsPlaylist[frag.sn - 1],
    'codecChanged',
    frag.codecChanged
  );
  if (frag.codecChanged) {
    component.$set(
      component.hlsPlaylist[frag.sn - 1].hole,
      'type',
      FragmentHoleType.CodecChanged
    );
  }
};

export const handleFragmentBuffered = (component, frag) => {
  component.handleFragmentBuffered(frag);
};

export const handleKVSCodecIsNotTheSame = (component, data) => {
  component.handleKVSCodecIsNotTheSame(data);
};

export const handleStreamingSessionExpired = (component) => {
  component.handleStreamingSessionExpired();
};

export const handleNoFragmentChange = (component) => {
  component.handleNoFragmentChange();
};

export const handleCanNotRecover = (component, frag) => {
  component.handleCanNotRecover(frag);
};

export const handleFragmentLoaded = (component, frag, prevFrag) => {
  component.handleFragmentLoaded(frag, prevFrag);
};

export const handleFragmentChanged = (
  component,
  { frag, prevFrag, startPosition }
) => {
  component.handleFragmentChanged({ frag, prevFrag, startPosition });
};

export const handleNoData = (component) => {
  component.handleNoData();
};
